import { useState } from 'react';
import { CardAction } from '@/common/components/CardAction/CardAction';
import { CardActionDownload } from '@/common/components/CardActionDownload/CardActionDownload';
import { CardActionGroup } from '@/common/components/CardActionGroup/CardActionGroup';
import { CardActionLink } from '@/common/components/CardActionLink/CardActionLink';
import { CardActionToggle } from '@/common/components/CardActionToggle/CardActionToggle';
import { CardActionUpload } from '@/common/components/CardActionUpload/CardActionUpload';
import { CardActionUploadGroup } from '@/common/components/CardActionUploadGroup/CardActionUploadGroup';
import { Icon } from '@/common/components/Icons/Icon';
import { Stack } from '@/common/components/Stack/Stack';
import { IFile } from '@coverflex-tech/hypernova-utils';

export const PlaygroundCards = () => {
  const [checked, setChecked] = useState(false);
  const [file, setFile] = useState<IFile>();
  const [files, setFiles] = useState<IFile[]>([]);
  return (
    <Stack gap="lg">
      <CardActionLink title="Card Action Link" href="" external />
      <CardActionLink
        title="Card Action Link"
        href=""
        external
        description="Description"
      />
      <CardActionLink
        title="Card Action Link - Medium"
        description="Description"
        href=""
        size="md"
        external
        plain
      />
      <CardActionToggle
        title="Card Action Toggle"
        checked={checked}
        onChange={() => {
          setChecked((prevChecked) => !prevChecked);
        }}
      />
      <CardActionToggle
        title="Card Action Toggle"
        description="Description"
        checked={checked}
        onChange={() => {
          setChecked((prevChecked) => !prevChecked);
        }}
      />
      <CardActionToggle
        title="Card Action Toggle - Medium"
        description="Description"
        checked={checked}
        onChange={() => {
          setChecked((prevChecked) => !prevChecked);
        }}
        plain
      />
      <CardActionGroup>
        <CardActionDownload
          title="Card Action File - Download"
          description="Description"
          fileUrl="https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf"
        />
        <CardActionLink
          icon={<Icon icon="user" />}
          title="Card Action Group - Item 1"
          href=""
          external
        />
        <CardAction
          icon={<Icon icon="credit-card" />}
          iconBadgeColor="accentSecondary30"
          title="Card Action Group - Item 2"
        />
        <CardActionLink title="Card Action Group - Item 3" href="" external />
        <CardActionLink title="Card Action Group - Item 4" href="" external />
      </CardActionGroup>
      <CardActionUpload
        title="Card Action File - Upload"
        description="Description"
        file={file}
        onChange={setFile}
        disabled
      />
      <CardActionDownload
        title="Card Action File - Download"
        description="Description"
        fileUrl="https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf"
      />
      <CardActionUploadGroup
        title="Card Action File Group"
        description="Description"
        cardTitle="Document"
        size="sm"
        files={files}
        onChange={setFiles}
      />
    </Stack>
  );
};
